// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.global-loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 2147483000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: rgba(17, 24, 39, 0.42);
  cursor: wait;
}

.global-loading-overlay__dialog {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;
  min-height: 150px;
  padding: 1.5rem;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.24);
}

.global-loading-overlay .loading-spinner__label {
  color: #1f2937;
}
`, "",{"version":3,"sources":["webpack://./src/styles/GlobalLoadingOverlay.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".global-loading-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 2147483000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: rgba(17, 24, 39, 0.42);\n  cursor: wait;\n}\n\n.global-loading-overlay__dialog {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 180px;\n  min-height: 150px;\n  padding: 1.5rem;\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.24);\n}\n\n.global-loading-overlay .loading-spinner__label {\n  color: #1f2937;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
